import { render, staticRenderFns } from "./MapObjectStatusConfiguration.vue?vue&type=template&id=367f9772&scoped=true&"
import script from "./MapObjectStatusConfiguration.vue?vue&type=script&lang=js&"
export * from "./MapObjectStatusConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./MapObjectStatusConfiguration.vue?vue&type=style&index=0&id=367f9772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f9772",
  null
  
)

export default component.exports